<template>
  <el-form
    ref="form"
    :model="form"
    :rules="rules"
    :label-position="labelPosition"
    :label-width="labelWidth"
    class="consult-form"
  >
    <el-form-item label="姓名" prop="name">
      <el-input v-model="form.name" placeholder="请输入姓名" clearable />
    </el-form-item>

    <el-form-item label="电话" prop="phone">
      <el-input v-model="form.phone" placeholder="请输入电话" clearable maxlength="20" />
    </el-form-item>

    <el-form-item label="公司名称" prop="company">
      <el-input v-model="form.company" placeholder="请输入公司名称" clearable />
    </el-form-item>

    <el-form-item label="职务" prop="jobTitle">
      <el-input v-model="form.jobTitle" placeholder="请输入职务" clearable />
    </el-form-item>

    <el-form-item label="邮箱" prop="email">
      <el-input v-model="form.email" placeholder="请输入邮箱" clearable />
    </el-form-item>

    <el-form-item label="需求" prop="description">
      <el-input
        v-model="form.description"
        type="textarea"
        :rows="4"
        placeholder="请输入您的需求"
        resize="vertical"
      />
    </el-form-item>

    <!-- <el-form-item label="验证码" prop="captcha">
      <div class="captcha-row">
        <div class="captcha-image" title="点击刷新验证码" @click="refreshCaptcha">
          <span
            v-for="(char, index) in captchaCode.split('')"
            :key="index + captchaCode"
            class="captcha-char"
            :style="charStyle(index)"
          >{{ char }}</span>
        </div>
        <el-input
          v-model="form.captcha"
          placeholder="请输入验证码"
          clearable
          maxlength="6"
          class="captcha-input"
        />
      </div>
    </el-form-item> -->

    <el-form-item v-if="showSubmit" class="submit-item">
      <el-button
        type="primary"
        :loading="submitting"
        class="submit-btn"
        @click="handleSubmit"
      >
        立即提交
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { generateCaptcha, verifyCaptcha } from '@/utils/captcha'

export function createEmptyConsultForm() {
  return {
    name: '',
    phone: '',
    company: '',
    jobTitle: '',
    email: '',
    description: '',
    captcha: ''
  }
}

export default {
  name: 'ConsultForm',
  props: {
    labelPosition: {
      type: String,
      default: 'top'
    },
    labelWidth: {
      type: String,
      default: '80px'
    },
    showSubmit: {
      type: Boolean,
      default: true
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value || !String(value).trim()) {
        callback(new Error('请输入电话'))
      } else if (!/^1[3-9]\d{9}$/.test(value) && !/^[\d\-+() ]{7,20}$/.test(value)) {
        callback(new Error('请输入正确的电话号码'))
      } else {
        callback()
      }
    }

    const validateEmail = (rule, value, callback) => {
      if (!value || !String(value).trim()) {
        callback()
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        callback(new Error('请输入正确的邮箱地址'))
      } else {
        callback()
      }
    }

    const validateCaptcha = (rule, value, callback) => {
      if (!value || !String(value).trim()) {
        callback(new Error('请输入验证码'))
      } else if (!verifyCaptcha(value, this.captchaCode)) {
        callback(new Error('验证码不正确'))
      } else {
        callback()
      }
    }

    return {
      form: createEmptyConsultForm(),
      captchaCode: generateCaptcha(),
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
        email: [{ validator: validateEmail, trigger: 'blur' }],
        captcha: [{ required: true, validator: validateCaptcha, trigger: 'blur' }]
      }
    }
  },
  methods: {
    charStyle(index) {
      const rotate = (index % 2 === 0 ? 1 : -1) * (8 + index * 3)
      return {
        transform: `rotate(${rotate}deg)`,
        color: ['#0066ff', '#e55a00', '#333', '#009944'][index % 4]
      }
    },
    refreshCaptcha() {
      this.captchaCode = generateCaptcha()
      this.form.captcha = ''
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate('captcha')
      })
    },
    reset() {
      this.form = createEmptyConsultForm()
      this.refreshCaptcha()
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const payload = {
          name: this.form.name.trim(),
          phone: this.form.phone.trim(),
          company: this.form.company.trim(),
          jobTitle: this.form.jobTitle.trim(),
          email: this.form.email.trim(),
          description: this.form.description.trim()
        }
        this.$emit('submit', payload)
      })
    },
    submit() {
      this.handleSubmit()
    }
  }
}
</script>

<style lang="scss" scoped>
.consult-form {
  ::v-deep .el-form-item__label {
    font-weight: 600;
    color: $text-primary;
    line-height: 1.4;
    padding-bottom: 6px;
  }

  ::v-deep .el-input__inner,
  ::v-deep .el-textarea__inner {
    border-radius: 4px;

    &:focus {
      border-color: $primary-color;
    }
  }

  ::v-deep .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::before {
    color: #f56c6c;
  }

  ::v-deep .el-textarea__inner {
    font-family: Noto Sans SC, sans-serif, 微软雅黑 !important;
  }
}

.el-form-item {
  margin-bottom: 15px !important;
}

.captcha-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.captcha-image {
  flex-shrink: 0;
  width: 110px;
  height: 40px;
  background: linear-gradient(135deg, #f0f4ff 0%, #e8ecf5 100%);
  border: 1px solid $border-color;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  letter-spacing: 4px;

  &:hover {
    border-color: $primary-color;
  }
}

.captcha-char {
  display: inline-block;
  font-size: 20px;
  font-weight: 700;
  font-family: 'Courier New', monospace;
}

.captcha-input {
  flex: 1;
}

.submit-item {
  margin-bottom: 0;
  margin-top: 8px;

  ::v-deep .el-form-item__content {
    margin-left: 0 !important;
  }
}

.submit-btn {
  width: 100%;
  height: 40px;
  font-size: 15px;
  @include brand-gradient-bg;
  border-color: #fff;

  &:hover {
    @include brand-gradient-bg;
    border-color: #fff;
  }
}

@media (max-width: 576px) {
  .captcha-row {
    flex-direction: column;
    align-items: stretch;
  }

  .captcha-image {
    width: 100%;
  }

  .submit-btn {
    width: 100%;
  }
}
</style>
